<script setup lang="ts">
import { useLoadingStore, useUserStore } from '../../stores';
import logo from '../../assets/imgs/iclass-logo.svg?url';
import { API_URL, SURVEY_KEY } from '../../configs/api';
import { ref, watchEffect } from 'vue';
import 'bo-rating-component';

const _materialIconsHref = 'https://fonts.googleapis.com/icon?family=Material+Icons';
if (!document.querySelector(`link[href="${_materialIconsHref}"]`)) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = _materialIconsHref;
    document.head.appendChild(link);
}

const loading = useLoadingStore()
const user = useUserStore()

const surveyUsername = ref<string | undefined>()
const isShowSurvey = ref<boolean>(false)

watchEffect(() => {
    if (user.username) {
        surveyUsername.value = user.username.split(',')[0]
    }

    if (loading.isClassFinished) {
        isShowSurvey.value = true
    }
})

</script>

<template>
    <Teleport to="body">
        <star-rating-popup v-if="API_URL.survey && surveyUsername && isShowSurvey" :logo="logo"
            :api-url="API_URL.survey" :survey-key="SURVEY_KEY" :user-name="surveyUsername" app-code="iclass"
            @closePopup="isShowSurvey = false" />
    </Teleport>
</template>